// extracted by mini-css-extract-plugin
export default {"popup_wrap":"bidError_popup_wrap__-6jdp","popup_message":"bidError_popup_message__6KMRT","popup_message_button":"bidError_popup_message_button__mfwss"};